import React from 'react'
import {message} from 'antd'
import {API_CODE_NO_PERMISSION, API_CODE_USER_NOT_ACTIVE, CLOSE_TIME} from '../../config'

export const networkClosedCode = -100000

export const DEFAULT_MSG = '网络不给力,请稍后再试试吧'

const errorList = {
  [100002]: {enable: false, msg: ''},
  [networkClosedCode]: {enable: true, msg: '请启用蜂窝移动数据或Wi-Fi访问'},
  [-1]: {enable: true, msg: DEFAULT_MSG},
  [API_CODE_NO_PERMISSION]: {enable: true, msg: '用户没有此功能的权限， 请联系管理员开通'},
  [API_CODE_USER_NOT_ACTIVE]: {enable: true, msg: '账号已被禁用，请联系管理员处理'}
}

export default (retCode, retMsg) => {
  // if (retCode && errorList[retCode]) {
  //   errorList[retCode].enable && message.error(errorList[retCode].msg, CLOSE_TIME)
  // }
  message.error(retMsg, CLOSE_TIME)
}



// WEBPACK FOOTER //
// ./src/lib/util/errorTip.js